import React from 'react';
import { metrics } from '../data/metrics';
export function MetricsBand() {
  const [lead, ...rest] = metrics;
  return <section aria-labelledby="metrics-title" className="bg-navy" data-id="element-147" data-mp="2pbv9od31vrxu">
      <div className="mx-auto max-w-shell px-6 py-16 lg:px-10 lg:py-20" data-id="element-148" data-mp="331qfx3aig07v">
        <h2 id="metrics-title" className="text-[11px] font-semibold uppercase tracking-overline text-bronze-400" data-id="element-149" data-mp="333te4altgzno">
          Track Record at a Glance
        </h2>

        <dl className="mt-10 grid gap-y-10 border-t border-white/15 pt-10 sm:grid-cols-2 lg:grid-cols-5 lg:gap-x-0" data-id="element-150" data-mp="3d293o95740v2">
          <div className="flex flex-col lg:col-span-2 lg:border-r lg:border-white/15 lg:pr-10" data-id="element-151" data-mp="3m0uh5pvt8poz">
            <dt className="font-serif text-5xl leading-none text-white lg:text-6xl" data-id="element-152" data-mp="3hz99qk21p3m6">
              {lead.value}
            </dt>
            <dd className="mt-5 text-base font-semibold text-white" data-id="element-153" data-mp="1rm1qm59sap3w">{lead.label}</dd>
            <dd className="mt-2 max-w-xs text-sm leading-relaxed text-steel-300" data-id="element-154" data-mp="1nlq6ctlc2qsy">
              {lead.detail}
            </dd>
          </div>

          {rest.map((metric, i) => <div key={metric.value} className={['flex flex-col lg:px-8', i < rest.length - 1 ? 'lg:border-r lg:border-white/15' : ''].join(' ')} data-id="element-155" data-mp="bfl0yoqq6n86" data-mpi={i}>
              <dt className="font-serif text-3xl leading-none text-white" data-id="element-156" data-mp="l6fzosl5rfai">
                {metric.value}
              </dt>
              <dd className="mt-4 text-sm font-semibold text-white" data-id="element-157" data-mp="q3xxbmtq6837">{metric.label}</dd>
              <dd className="mt-2 text-sm leading-relaxed text-steel-300" data-id="element-158" data-mp="u4rm0iezrqx5">
                {metric.detail}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}